import PATHS from 'src/router/paths'

const columns = {
  [PATHS.DASHBOARD.BASE]: [],
  [PATHS.DASHBOARD.HOME]: [],
}

export default columns
